import classNames from 'classnames'
import { StencilCDNImage } from '@/components/Common/StencilImage'
export default function Widget({
  image,
  alt_text,
  width = 420,
  parentWidthClass = 'lg:min-w-fit',
}: {
  image?: string
  alt_text?: string
  width?: number
  parentWidthClass?: string
}) {
  return (
    <li
      className={classNames(
        'min-w-full rounded-xl px-1  py-4',
        parentWidthClass,
      )}
    >
      <div className="flex gap-1">
        {image ? (
          <StencilCDNImage
            src={image}
            width={width}
            height={width}
            className="rounded-xl p-0"
            alt={alt_text}
          />
        ) : (
          <div className=" h-72 w-72 bg-white" />
        )}
      </div>
    </li>
  )
}
